import axios from "axios";

export const client = axios.create({
    baseURL: process.env.REACT_APP_API_SERVER_URL + "/"
});

let helpers = {};
// Add it to your helpers object
export function loadToken({ getAccessTokenSilently, loginWithRedirect }) {
    helpers.getAccessTokenSilently = getAccessTokenSilently;
    helpers.loginWithRedirect = loginWithRedirect;
}

// 1. Define your Hash Table (Dictionary) outside the function
// Map exact hostnames to their exact Auth0 Enterprise Connection names


async function getToken() {
    let options = {
        authorizationParams: {
            audience: process.env.REACT_APP_AUTH0_AUDIENCE
        },
    };

    // debugger;

    try {
        const token = await helpers.getAccessTokenSilently(options);
        return token;
    } catch (e) {
        console.warn("Silent token retrieval failed. Redirecting to login...", e);

        const customDomainMap = {
            'mbta.nucleus.mercuryinnovation.com.au': 'MBTA-OpenID',
            'yjm.nucleus.mercuryinnovation.com.au': 'yjm-nucleus',
            'testing.nucleus.mercuryinnovation.com.au': 'OpenID-Connect'
        };

        if (helpers.loginWithRedirect) {
            const loginOptions = {
                appState: { returnTo: window.location.pathname }
            };

            const hostname = window.location.hostname;
            console.log(hostname)

            // 2. Priority 1: Check if the full domain exists in the hash table
            if (customDomainMap[hostname]) {
                loginOptions.authorizationParams = {
                    connection: customDomainMap[hostname]
                };
            }
            // 3. Priority 2: Fallback to the dynamic subdomain logic
            else {
                const parts = hostname.split('.');

                if (parts.length > 0 && parts[0] !== 'nucleus' && parts[0] !== 'www' && parts[0] !== 'localhost') {
                    const subdomain = parts[0];
                    loginOptions.authorizationParams = {
                        connection: subdomain
                    };
                }
            }

            // 4. Fire the redirect
            helpers.loginWithRedirect(loginOptions);
        }

        throw e;
    }
}

// Your interceptor stays exactly the same!
client.interceptors.request.use(async function (config) {
    if (helpers.getAccessTokenSilently) {
        try {
            const token = await getToken();
            if (token) {
                config.headers.Authorization = `Bearer ${token}`;
            }
        } catch (error) {
            return Promise.reject(error);
        }
    }

    const selectedOrg = localStorage.getItem("selectedOrg");
    if (selectedOrg) {
        config.headers["x-selected-org"] = selectedOrg;
    }

    return config;
});